import { Button, grey, Stack, Typography } from "@bvhi/ui-base";
import { ExpandMoreIcon } from "@bvhi/ui-icons";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
}

export const BVHIExpandComponent = ({ expanded, setExpanded }: Props) => {
  const { t } = useTranslation(["users"]);
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      mb={2}
      sx={{
        userSelect: "none",
        "&:hover .expandable-chip": {
          background: grey[400],
          cursor: "pointer",
        },
      }}
    >
      <Typography variant="h6">{t("users.card.filter.subtitle")}</Typography>
      <Stack alignItems="center" direction="row" spacing={1}>
        <Button
          color="secondary"
          endIcon={<ExpandMoreIcon />}
          variant="text"
          onClick={() => {
            setExpanded((prev) => !prev);
          }}
          sx={{
            transition: (theme) =>
              theme.transitions.create(["background"], {
                duration: theme.transitions.duration.shortest,
              }),
            "& .MuiButton-endIcon": {
              transition: (theme) =>
                theme.transitions.create("transform", {
                  duration: theme.transitions.duration.shortest,
                }),
              transform: !expanded ? "rotate(0deg)" : "rotate(180deg)",
            },
          }}
        >
          {expanded ? t("users.card.filter.button.shrink") : t("users.card.filter.button.expand")}
        </Button>
      </Stack>
    </Stack>
  );
};
